import { Button } from "@/components/ui/button";

export const Step3 = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-[#14142A] px-5 py-10 text-white">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold text-green-600">Success</h1>
        <p className="text-xl">Reset key has been sent to your email</p>
      </div>
      <div className="mt-6 flex justify-center">
        <Button className="hover:bg-blue-600 rounded-md bg-orange-400 px-4 py-2 text-white">
          Check your email
        </Button>
      </div>
    </div>
  );
};
